import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import BeneAccountViewAllPopup from "../../../../Accounts/BeneAccount/BeneAccountViewAllPopup";
import InternalAccountPopUp from "../../../../Accounts/InternalAccountPopUp";
import OwnerAccountPopUp from "../../../../Accounts/OwnerAccountPopUp";

const CommonAccountModal = ({
  onClose,
  onAccountSelect,
  ispanbankRequired,
  sourceDestiAcc,
  type,
  associateAccount,
  panNumber,
  IFSC,
  accountNumber,
  setOpenInternalAssociate,
  setOpenBeneAssociate,
  beneAccountId,
  accountType,
  flow,
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  BeneTxnAssocAcct,
  setAssociateModalOpen,
  associateTxn,
  scheduleIntenralTxn,
  type1,
  name1,
  LabelAccounts,
  setOpenOwner,
  associateModalOpen,
  activeType,
  setActiveType,
  setRemPan,
  setRemAccount,
  setRemIFSC,
  remIFSC,
  remAccount,
  remPan,
  subType,
  TypeRTGS,
  currentAccountDetails,
  flowType,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(disableSwitcher());

    return () => {
      dispatch(enableSwitcher());
    };
  }, []);
  const handleButtonClick = (dataItem) => {
    if (type === "source") {
      onAccountSelect(
        dataItem?.name?.trim(),
        dataItem?.bank_acc_no?.trim(),
        dataItem?.ifsc_code?.trim(),
        dataItem?.id?.trim(),
      );
    } else if (type === "ReibursementRequestMulti") {
      onAccountSelect(
        dataItem?.name?.trim(),
        dataItem?.bank_acc_no?.trim(),
        dataItem?.ifsc_code?.trim(),
        dataItem?.id,
        dataItem,
      );
      setOpenOwner?.(false);
    } else {
      if (type === "viewAll") {
        onAccountSelect(
          dataItem.name.trim(),
          dataItem.bank_acc_no.trim(),
          dataItem.ifsc_code.trim(),
          dataItem.id,
        );
      } else {
        onAccountSelect(
          dataItem?.name.trim(),
          dataItem?.bank_acc_no.trim(),
          dataItem?.ifsc_code.trim(),
          dataItem?.bank_name,
          dataItem?.category,
          dataItem?.pan_no,
          dataItem?.id,
          dataItem?.labels,
          dataItem?.internal_account,
        );

        if (associateTxn === "associateTxn") {
          setOpenInternalAssociate(false);
        }

        if (BeneTxnAssocAcct) {
          setAssociateModalOpen(false);
        }
      }
    }
  };

  return (
    <>
      <div className="">
        {flow === "beneTxn" && type !== "source" ? (
          <BeneAccountViewAllPopup
            subType={subType}
            sourceDestiAcc={sourceDestiAcc}
            ispanbankRequired={ispanbankRequired}
            typepop={"popup"}
            onClosepop={onClose}
            handleButtonClick={handleButtonClick}
            associateAccount={associateAccount}
            associatepanNumber={panNumber}
            associateIFSC={IFSC}
            associateaccountNumber={accountNumber}
            setOpenInternalAssociate={setOpenInternalAssociate}
            setOpenBeneAssociate={setOpenBeneAssociate}
            beneAccountId={beneAccountId}
            BeneTxnAssocAcct={BeneTxnAssocAcct}
            accountType={accountType}
            flow={flow}
            setTxnPayLoad={setTxnPayLoad}
            txnPayLoad={txnPayLoad}
            setIsNeft={setIsNeft}
            setIsImps={setIsImps}
            setIsRtgs={setIsRtgs}
            setAssociateModalOpen={setAssociateModalOpen}
            associateTxn={associateTxn}
            type1={type1}
            name1={name1}
            flowType={flowType}
            alertPop={"AlertPopAsso"}
            onAccountSelect={onAccountSelect}
            activeType={activeType}
            setActiveType={setActiveType}
            setRemPan={setRemPan}
            setRemAccount={setRemAccount}
            setRemIFSC={setRemIFSC}
            remIFSC={remIFSC}
            remAccount={remAccount}
            remPan={remPan}
            typePanBank={
              flow === "beneTxn" && type !== "source"
                ? "BeneAccPanBankSwitch"
                : ""
            }
          />
        ) : type !== "source" && type !== "ReibursementRequestMulti" ? (
          <InternalAccountPopUp
            typepop={"popup"}
            onClosepop={onClose}
            handleButtonClick={handleButtonClick}
            associateAccount={associateAccount}
            associatepanNumber={panNumber}
            associateIFSC={IFSC}
            associateaccountNumber={accountNumber}
            setOpenInternalAssociate={setOpenInternalAssociate}
            setOpenBeneAssociate={setOpenBeneAssociate}
            beneAccountId={beneAccountId}
            BeneTxnAssocAcct={BeneTxnAssocAcct}
            accountType={accountType}
            flow={"internalTxn"}
            setTxnPayLoad={setTxnPayLoad}
            txnPayLoad={txnPayLoad}
            setIsNeft={setIsNeft}
            setIsImps={setIsImps}
            setIsRtgs={setIsRtgs}
            setAssociateModalOpen={setAssociateModalOpen}
            associateTxn={associateTxn}
            scheduleIntenralTxn={scheduleIntenralTxn}
            LabelAccounts={LabelAccounts}
            onAccountSelect={onAccountSelect}
          />
        ) : (
          <OwnerAccountPopUp
            onClose={onClose}
            setOpenOwner={setOpenOwner}
            setIsNeft={setIsNeft}
            setIsImps={setIsImps}
            setIsRtgs={setIsRtgs}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            handleButtonClick={handleButtonClick}
            ownerId={txnPayLoad?.owner_id}
            flow={
              flow === "ReibursementRequestMultiFlow"
                ? "ReibursementRequestMultiFlow"
                : "createTxn"
            }
            TypeAccount="InternalAccountTxn"
            type={type}
            TypeRTGS={TypeRTGS}
            currentAccountDetails={currentAccountDetails}
          />
        )}
      </div>
    </>
  );
};

export default CommonAccountModal;
